import React, {useState, useEffect}  from 'react'
import intl from 'react-intl-universal';
import Swiper from "swiper"
import "swiper/css/swiper.css"
import { useHistory } from "react-router-dom"
import { langPath} from "@/util";
import '@/assets/css/home.scss'
import '@/assets/css/common.scss'
const categorys = [
    {
        text: '耳环',
        enText: 'Stylish Earrinngs',
        id: 6,
        img: 'https://yunhong-rt.oss-cn-shanghai.aliyuncs.com/rt-mobile/home/c-1.jpg',
    },
    {
        text: '项链',
        enText: 'Dramatic Necklace',
        img: 'https://yunhong-rt.oss-cn-shanghai.aliyuncs.com/rt-mobile/home/c-2.jpg',
        id: 7
    },
    {
        text: '手链',
        enText: 'Inspiring Bracelet',
        img: 'https://yunhong-rt.oss-cn-shanghai.aliyuncs.com/rt-mobile/home/c-3.jpg',
        id: 8
    },
    {
        text: '戒指',
        enText: 'Iconic Ring',
        img: 'https://yunhong-rt.oss-cn-shanghai.aliyuncs.com/rt-mobile/home/c-4.jpg',
        id: 9
    },
    {
        text: '发饰',
        enText: 'Hair Ornament',
        img: 'https://yunhong-rt.oss-cn-shanghai.aliyuncs.com/rt-mobile/home/c-5.jpg',
        id: 10
    },
    {
        text: '眼镜',
        enText: 'Fancy Glasses',
        img: 'https://yunhong-rt.oss-cn-shanghai.aliyuncs.com/rt-mobile/home/c-6.jpg',
        id: 14
    }
]
const banners = [
    {
        img: 'https://yunhong-rt.oss-cn-shanghai.aliyuncs.com/rt-mobile/home/banner-4.jpg',
        type: 'page',
        url: ''
    },
    {
        img: 'https://yunhong-rt.oss-cn-shanghai.aliyuncs.com/rt-mobile/home/banner-1.jpg',
        type: 'page',
        url: '/goods?c=13&t=c'
    },
    {
        img: 'https://yunhong-rt.oss-cn-shanghai.aliyuncs.com/rt-mobile/home/banner-2.jpg',
        type: 'des',
        url: '/dec/25',
        id: 25
    },
    {
        img: 'https://yunhong-rt.oss-cn-shanghai.aliyuncs.com/rt-mobile/home/banner-3.jpg',
        type: 'page',
        url: '/story'
    }
]
const Home = () => {
    const [cateNavs] = useState(categorys)
    const [banner] = useState(banners)

    const history = useHistory()
    const goPage = (id, type = 'cate') => {
        let path = type === 'cate' ? `/goods?c=${id}&t=c` : 'store'
        history.push(langPath(path))
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
    }

    useEffect(() => {
        new Swiper ('.swiper-container', {
            loop: true,
            speed: 800,
            slidesPerView: 'auto', // or 'auto'
            autoHeight: true,
            autoplay: {
                delay: 2000,
                stopOnLastSlide: false,
                disableOnInteraction: false
            },
            // spaceBetween: 10,
            centeredSlides: true,
            effect: 'slide', // 'cube', 'fade', 'coverflow',
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            }
        })
    }, [])
    return (
        <div className="rl">
            <div className="rl-home rl-container">
                <div className="item item1">
                    <div className="item1-left">
                        <img src="https://yunhong-rt.oss-cn-shanghai.aliyuncs.com/rt-mobile/home/01.png" alt=""/>
                    </div>
                    <div className="item1-right"/>
                </div>
                <div className="item item2">
                    <div className="swiper-container">
                        <div className="swiper-wrapper">
                            {
                                banner.map((val) => {
                                    return (
                                        <div key={val.img}
                                             className="swiper-slide"
                                             onClick={() => { if (!val.url) return; history.push(langPath(val.url))}}
                                        >
                                            <div className="swiper-box">
                                                <img src={val.img} alt=""/>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
                <div className="item item3">
                    <div className="left">
                        RECOMMENDATIONS
                    </div>
                </div>
                <div className="item item4">
                    <div className="cate-list">
                        {
                            cateNavs.map(val => {
                                return (
                                    <div className="cate-item" key={val.id} onClick={() => goPage(val.id)}>
                                        <img src={ val.img } alt=""/>
                                        <div className="cate-des">
                                            <p className="cate-en">{ val.enText }</p>
                                            <p className="cate-cn">{ val.text }</p>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
                <div className="item item3">
                    <div className="left">
                        RIOTLILY TIME
                    </div>
                </div>
                <div className="item item5">
                    <div className="vedio-box">
                        <video

                            webkit-playsinline="true"
                            id="media"
                            width="100%"
                            autoPlay="autoplay"
                            controls
                            muted="muted"
                            playsInline={true}
                            preload="auto"
                        >
                            <source src="https://yunhong-rt.oss-cn-shanghai.aliyuncs.com/rt-mobile/home/v1.mp4"/>
                        </video>
                    </div>
                </div>
                <div className="item item3">
                    <div className="left">
                        BOUTIQUES
                    </div>
                </div>
                <div className="item item6">
                    <div className="address-info info1">
                        {intl.get('home').text && intl.get('home').text[0]}
                    </div>
                    <div className="address-info info2">
                        <p>
                            {intl.get('home').text && intl.get('home').text[1]}
                        </p>
                        <p>{intl.get('home').text && intl.get('home').text[2]}</p>
                        <p>{intl.get('home').text && intl.get('home').text[3]}</p>
                    </div>
                    <div className="address-info info3" onClick={() => goPage('0', 'store')}>
                        {intl.get('home').btn}>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Home
